export const ENCUMBRANCE_EXCEL_SHEET_NAME = 'Gravamenes';

export const ENCUMBRANCE_EXCEL_HEADERS = [
  'ENCUMBRANCE_ID',
  'TYPE',
  'SHARE_FROM',
  'SHARE_TO',
  'TOTAL_SHARES',
  'DATE',
  'END_DATE',
  'HOLDER_CIF',
  'HOLDER_NAME',
  'ROLE',
  'PARTY_CIF',
  'PARTY_NAME',
  'PARTY_EMAIL',
  'PERCENTAGE',
  'COMMENTS',
] as const;

export const ENCUMBRANCE_EXCEL_TYPES = new Set([
  'CO_OWNERSHIP',
  'USUFRUCT',
  'PLEDGE_OR_GUARANTEE',
  'EMBARGO',
]);

export const ENCUMBRANCE_EXCEL_ROLES = new Set([
  'HOLDER',
  'CO_OWNER',
  'USUFRUCTUARY',
  'CREDITOR',
]);
